export const KEYCHAIN_URL = "https://x.cartridge.gg";
export const PROFILE_URL = "https://profile.cartridge.gg";
export const API_URL = "https://api.cartridge.gg";
